import mutations from "@/store/mutations/insUserMediaMutation";
import getters from "@/store/getters/insUserMediaGetter";
import actions from "@/store/actions/insUserMediaAction";
/**
 * [INS] InsUserMediaList DATA
 */
export default {
  state: {
    insUserMediaList: []
  },
  mutations,
  getters,
  actions
};
